import { observable, computed, decorate } from 'mobx';

class StateStore {

    customer = null;
    purchaseUrl = null;
    tickets = observable.map({});
    //discountAmount = observable.box(0);
    processingPurchase = observable.box(false);
    cashsale = observable.box(null);
    errors = observable([]);

    initCustomer(inputedCustomer) {
        this.customer = inputedCustomer;
        if (this.customer.hasCommunitySubscription === 'T') {
            this.customer.hasCommunitySubscription = true;
        }
        else {
            this.customer.hasCommunitySubscription = false;
        }        
    }
        
    initTickets(inputTickets) {
        inputTickets.map(ticket => {
            ticket.quantity = 0;  
            if(ticket.usedCommunityDiscount === 'F' || ticket.price === '0') {
                ticket.usedCommunityDiscount = false;
            }    
            else {
                ticket.usedCommunityDiscount = true;
            }
            this.tickets.set(ticket.id, ticket);
            //this.changeTicketQuantity(ticket.id, 1)
            return true;
        });
    }

    changeTicketQuantity(ticketId, quantity) {
        let ticket = this.tickets.get(ticketId);
        ticket.quantity = quantity;
        //this.applyCommunityDiscount();
    }

    getLineItemTotal(ticketId) {         
        const ticket = this.tickets.get(ticketId);      
        const price =  parseFloat(ticket.price);
        let total = parseFloat(price * ticket.quantity).toFixed(2);
        if (this.customer.hasCommunitySubscription) {
            total = parseFloat(total) - price;
            total = total.toFixed(2);
        } 
        return total;
    }    

    /*getSubtotal() {
        let subtotal = 0;
        for (const ticket of this.tickets.values()) {
            if (ticket.quantity > 0) {
                subtotal = parseFloat(subtotal) + parseFloat(ticket.price);
                subtotal = parseFloat(subtotal).toFixed(2);               
            }
        }   
        return subtotal;      
    }*/

    getTotal() {
        let total = 0.00;
        for (const ticket of this.tickets.values()) {
            if (ticket.quantity > 0) {
                total = parseFloat(total) + this.getLineItemTotal(ticket.id);
                total = parseFloat(total).toFixed(2);               
            }
        }   
        return parseFloat(total).toFixed(2); 
    }

    getTotalQuantity() {
        let quantity = 0;
        for (const ticket of this.tickets.values()) {
            quantity = parseInt(quantity, 10) + parseInt(ticket.quantity, 10);
        }   
        return parseInt(quantity, 10);        
    }

    /*applyCommunityDiscount() {
        if (!this.customer.hasCommunitySubscription) {
            return;
        }           
        let communityDiscount = 0;
        for (const ticket of this.tickets.values()) {
            if (ticket.quantity > 0) {
                communityDiscount = parseFloat(communityDiscount) + parseFloat(ticket.price);
                communityDiscount = parseFloat(communityDiscount).toFixed(2);               
            }
        }                    
        this.discountAmount.set(communityDiscount);        
        // TODO At some point, need to add community discount to general discount
        //  such as in below
        //this.discountAmount.set(this.discountAmount.get() + communityDiscount);        
    }*/

    isCartEmpty() {
        let quantity = 0;
        for (const ticket of this.tickets.values()) {
            quantity += ticket.quantity;
        }
        return (!(quantity > 0));
    }

    purchaseTickets() {
        this.processingPurchase.set(true);
        let purchaseTickets = [];
        for (const ticket of this.tickets.values()) {
            if (ticket.quantity > 0) {
                purchaseTickets.push({
                    id: ticket.id,
                    quantity: ticket.quantity,
                });            
            }
        }         
        const url = this.purchaseUrl;
        const body = {
            action: 'purchaseTickets',
            data: {
                customeremail: this.customer.email,
                tickets: purchaseTickets,
            },
        };
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers:{                
                'User-Agent': 'Mozilla/5.0',                
            }
        })
        .then(res => res.json())        
        .catch(error => {
            console.error('Error:', error);
            console.error(JSON.stringify(body));
        })
        .then(json => {
            //console.log(json);
            if (json.status !== 'ok') {
                this.errors.replace(json.errors);
            }
            else {
                this.cashsale.set(json.data);
            }
            this.processingPurchase.set(false);
        });
    }

    netsuiteBaseUrl = null;
    salesforceBaseUrl = null;
    // TODO Store session in sessionStore.
    //sessionToken = observable.box(null);
    //sessionToken = observable.box('eyJlbWFpbCI6InJveS5hc2xhbkBrYWJiYWxhaC5jb20ifQ==.bWn90XFWjWQwSYOquRwjqjGVNMk9nQ9Gm7J5mCf+5kw=');
    hasSessionToken = observable.box(false);
    sessionTokenRaw = null;
    guestSessionMode = false;
    processingLogin = observable.box(false);
    loadedPortalData = observable.box(false);
    attendances = observable([]);

    get sessionToken() {
        if (this.sessionTokenRaw) {
            return this.sessionTokenRaw;            
        }
        let storedToken = sessionStorage.getItem('sessionToken');
        if (storedToken) {            
            this.sessionTokenRaw = storedToken;
            return this.sessionTokenRaw;
        }        
        return null;
    }

    set sessionToken(token) {
        this.sessionTokenRaw = token; 
        sessionStorage.setItem('sessionToken', token);  
        this.hasSessionToken.set(true);  
    }

    login(email, password) {        
        this.processingLogin.set(true);
        const url = this.netsuiteBaseUrl + '&custom_mode=api';
        const body = {
            action: 'login',
            data: {
                email: email,
                password: password,
            },
        };
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers:{                
                'User-Agent': 'Mozilla/5.0',                
            }
        })
        .then(res => res.json())        
        .catch(error => {
            //console.error('Error:', error);
            //console.error(JSON.stringify(body));
        })
        .then(json => {
            //console.log(json);
            if (json.status !== 'ok') {
                this.errors.replace(json.errors);
            }
            else {
                //this.sessionToken.set(json.data.sessionToken); 
                /*sessionStorage.setItem('sessionToken', json.data.sessionToken);  
                this.hasSessionToken.set(true);*/
                this.sessionToken = json.data.sessionToken;
                console.log(this.sessionToken);                 
            }
            this.processingLogin.set(false);
        });                
    }

    fetchAttendances() {
        const url = this.salesforceBaseUrl + '/portal/';
        const body = {
            action: 'getStudentData',
            token: this.sessionToken,
        };
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers:{                
                'Content-Type': 'application/json',                
            }
        })
        .then(res => res.json())        
        .catch(error => {
            console.error('Error:', error);
            console.error(JSON.stringify(body));
        })
        .then(json => {
            //console.log(json);
            if (json.status !== 'ok') {
                this.errors.replace(json.errors);
            }
            else {
                this.attendances.replace(json.data);
                this.loadedPortalData.set(true);
            }
        });         
    }

    get courses() {
        if (!this.attendances.length) {
            return null;
        }
        let courses = {};
        this.attendances.map(attendance => {
            courses[attendance.course.Id] = attendance.course;
            courses[attendance.course.Id].sessions = {};
            return null;
        });  
        this.attendances.map(attendance => {
            courses[attendance.course.Id].sessions[attendance.session.Id] = attendance.session;
            return null;
        });          
        return courses;      
    }

    logout() {
        //this.sessionToken.set(null);
        //sessionStorage.removeItem('sessionToken');
        //this.hasSessionToken.set(false);
        this.sessionToken = null;
    }

    get claims() {
        if (!this.sessionToken) {
            return null;
        }
        let parts = this.sessionToken.split('.', 2);        
        if (parts.length !== 2) {
            return null;
        }
        let payload = null;
        try {
            payload = JSON.parse(atob(parts[0]));
        } catch(e) {
            return null;
        }
        if (!payload || !payload.email) {
            return null;
        }
        return payload;
    }

    get emailClaim() {
        let payload = this.claims;
        if (!payload || !payload.email) {
            return null;
        }
        return payload.email;
    }

}

decorate(StateStore, {
    getCourses: computed,
    getClaims: computed,
    getEmailClaim: computed,
    //getSessionToken: computed,
})
let store = new StateStore();
export default store;


// WEBPACK FOOTER //
// ./src/store.js